import { useState } from "react";
import ControlPanel from "./components/ControlPanel";
import LoginModal from "./components/LoginModal";
import { login } from "./api";
import "./App.css";

export default function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  async function handleLogin(username, password) {
    await login(username, password);
    setIsAuthenticated(true);
  }

  return (
    <div className="app-shell">
      {/* Login popup */}
      {!isAuthenticated && (
        <LoginModal onLogin={handleLogin} />
      )}

      {/* Dashboard */}
      {isAuthenticated && (
        <div className="dashboard">
          {/* URC Logo */}
          <div className="dashboard-logo">
            <img
              src="https://unitedrugby.com/wp-content/uploads/2025/08/REDUCED_URC_Logo_TurquoiseWhite_RGB.png"
              alt="United Rugby Championship"
            />
          </div>

          <ControlPanel />
        </div>
      )}
    </div>
  );
}
